module.exports = __webpack_public_path__ + "img/member-discount.dfadc761.png";